import * as types from '../actions/ActionTypes';
import { StylingUserCalendarInitialState } from './InitialState';
import { assign } from '../../../shared/Assign';
import moment from 'moment';

export default function calendarReducer(
    state: any = StylingUserCalendarInitialState,
    action: { type: string; result: any }
) {
    let newState = assign({}, state);

    switch (action.type) {
        case types.GET_STYLINGUSER_CALENDAR_SUCCESS:
            newState = action.result;
            newState.se360WorkingHours.map((x) => {
                x.start = moment(x.start, 'HH:mm:ss').toDate();
                x.end = moment(x.end, 'HH:mm:ss').toDate();
            });

            return newState;
        case types.UPDATE_STYLINGUSER_CALENDAR_SUCCESS:
            newState = action.result.calendar;
            newState.se360WorkingHours.map((x) => {
                x.start = moment(x.start, 'HH:mm:ss').toDate();
                x.end = moment(x.end, 'HH:mm:ss').toDate();
            });
            return newState;
        case types.GET_STYLINGUSER_EVENTS_SUCCESS:
            newState = action.result;
            return newState;
        case types.GET_STYLINGUSER_CALENDAR_PRINT_EVENTS_SUCCESS:
            newState = action.result;
            return newState;
        case types.DELETE_STYLINGUSER_CALENDAR_ITEM_SUCCESS:
            newState.items = newState.items.filter((x) => x.id !== action.result.id);
            return newState;
        case types.UPDATE_STYLINGUSER_CALENDAR_ITEM_SUCCESS:
            let c = newState.items.filter((x) => x.id !== action.result.id);
            action.result.editable = true;
            c.push(action.result);
            newState.items = c;
            return newState;
        case types.CREATE_STYLINGUSER_CALENDAR_ITEM_SUCCESS:
            if (!newState.items) {
                newState.items = [];
            }
            action.result.item.editable = true;
            if (action.result.id) {
                action.result.item.id = action.result.id;
            }
            newState.items.push(action.result.item);
            return newState;
        default:
            return state;
    }
}
